import React from "react";
import { Link } from "react-router-dom";
import logo from "../../../images/bitcoin-live/logo.png";
import { FOOTER_LINKS } from "../constants";
import {
  FooterBar,
  FooterContainer,
  FooterCta,
  FooterCtaTitle,
  FooterCtaLead,
  FooterCtaButton,
  FooterGrid,
  FooterBrandCol,
  FooterBrandLink,
  FooterLogo,
  FooterBrandText,
  FooterBrandAccent,
  FooterTagline,
  FooterSocial,
  FooterLinksCol,
  FooterLinksHeading,
  FooterLinksList,
  FooterLinkItem,
  FooterBottom,
  FooterCopyright,
  FooterDisclaimer,
} from "./Footer.styles";

const Footer = ({ onSubscribeClick, hideSubscribeCta = false }) => (
  <FooterBar>
    <FooterContainer>
      {!hideSubscribeCta && (
        <FooterCta>
          <FooterCtaTitle>
            Ready to Gain the <span>Edge</span>?
          </FooterCtaTitle>
          <FooterCtaLead>
            Join over 10,000 investors who trust our analysts for their Bitcoin
            strategy.
          </FooterCtaLead>
          <FooterCtaButton type="button" onClick={onSubscribeClick}>
            Start Your Subscription Now
          </FooterCtaButton>
        </FooterCta>
      )}

      <FooterGrid>
        <FooterBrandCol>
          <FooterBrandLink as={Link} to="/">
            <FooterLogo src={logo} alt="Bitcoin Live" />
            <FooterBrandText>
              bitcoin<FooterBrandAccent>.live</FooterBrandAccent>
            </FooterBrandText>
          </FooterBrandLink>
          <FooterTagline>
            Premium Bitcoin market analysis from world-class financial experts.
          </FooterTagline>
          <FooterSocial>
            <a
              href="https://twitter.com/BitcoinLive1"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Bitcoin Live on X"
            >
              <i className="fab fa-twitter" aria-hidden="true" />
            </a>
          </FooterSocial>
        </FooterBrandCol>

        <FooterLinksCol>
          <FooterLinksHeading>Legal</FooterLinksHeading>
          <FooterLinksList>
            {FOOTER_LINKS.map((item) => (
              <FooterLinkItem key={item.to}>
                <Link to={item.to}>{item.title}</Link>
              </FooterLinkItem>
            ))}
          </FooterLinksList>
        </FooterLinksCol>
      </FooterGrid>

      <FooterBottom>
        <FooterCopyright>
          © {new Date().getFullYear()} bitcoin.live. All rights reserved.
        </FooterCopyright>
        <FooterDisclaimer>
          Disclaimer: Content is for informational purposes only. Not financial
          advice. Past performance does not guarantee future results.
        </FooterDisclaimer>
      </FooterBottom>
    </FooterContainer>
  </FooterBar>
);

export default Footer;
